import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	issues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addIssueIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issuesIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addIssueIconLabelIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	issues: {
		id: 'software-releases-version-detail-issue-list.issues',
		defaultMessage: 'Issues',
		description:
			'Subheading for a section of the page which shows the issues that are within the version',
	},
	addIssueIconLabel: {
		id: 'software-releases-version-detail-issue-list.add-issue-icon-label',
		defaultMessage: 'Add issues',
		description: 'Label for the icon button to add issues',
	},
	issuesIssueTerminologyRefreshM4: {
		id: 'software-releases-version-detail-issue-list.issues-issue-terminology-refresh-m4',
		defaultMessage: 'Work items',
		description:
			'Subheading for a section of the page which shows the issues that are within the version',
	},
	addIssueIconLabelIssueTerminologyRefreshM4: {
		id: 'software-releases-version-detail-issue-list.add-issue-icon-label-issue-terminology-refresh-m4',
		defaultMessage: 'Add work items',
		description: 'Label for the icon button to add issues',
	},
});
export default messages;
